import { CSSObject } from '@chakra-ui/react';
import overviewBannerDesktop from '../../../../../../assets/questbet/images/backgrounds/overviewBannerDesktop.jpg';
import overviewBannerMobile from '../../../../../../assets/questbet/images/backgrounds/overviewBannerMobile.jpg';
import { BannerSchema } from '@/views/account/Overview/components/Banner/styles/Banner.styles';

export const bannerStyles: BannerSchema = {
  buttonDeposit: {
    h: 6,
    fontSize: 'xs',
    px: 3,
  },
};

export const FlexAccountDetails: CSSObject = {
  flexDir: ['column', null, 'row'],
  w: 'full',
  gap: '2',
  alignItems: ['unset', null, 'center'],
};

export const FlexAccountName: CSSObject = {
  fontSize: 'xl',
  color: 'alpha.800',
  fontWeight: 'semibold',
};

export const FlexBannerContainer: CSSObject = {
  p: '4',
  bg: [`url(${overviewBannerMobile})`, null, `url(${overviewBannerDesktop})`],
  '&&': {
    backgroundSize: 'cover',
    backgroundPosition: ['top', null, 'right'],
  },
  borderRadius: 'base',
  gap: ['2', null, 'unset'],
};

export const FlexLabel: CSSObject = {
  w: ['full', null, 'unset'],
  flex: '1',
};

export const FlexBalanceBetInfo: CSSObject = {
  px: '2',
  py: '1',
  bg: 'alpha.50',
  color: 'alpha.700',
  borderRadius: 'base',
  boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.2)',
  fontSize: '2xs',
  h: ['7', null, 'full'],
  fontWeight: 'extrabold',
  textTransform: 'uppercase',
  alignItems: 'center',
  justifyContent: 'center',
  flex: ['1', null, 'unset'],
};

export const FlexAccountBalances: CSSObject = {
  flexDir: 'row',
  gap: ['8', null, '6'],
  justifyContent: ['space-between', null, 'unset'],
};

export const TextButton: CSSObject = {
  alignSelf: 'center',
};

export const TextAccountBalanceLabel: CSSObject = {
  textTransform: 'uppercase',
  fontSize: 'xs',
  fontWeight: 'bold',
  color: 'alpha.600',
};

export const TextAccountBalanceBaseUnit = (): CSSObject => ({
  textTransform: 'uppercase',
  fontSize: 'xl',
  fontWeight: 'extrabold',
  color: 'alpha.800',
});

export const TextAccountBalanceSubUnit = (): CSSObject => ({
  textTransform: 'uppercase',
  fontSize: 'sm',
  fontWeight: 'extrabold',
  color: 'alpha.800',
});

export const TextAccountBalanceCurrencySymbol = (): CSSObject => ({
  mt: '0.5',
  mr: '0.5',
  alignSelf: 'flex-start',
  textTransform: 'uppercase',
  fontSize: 'xs',
  fontWeight: 'bold',
  color: 'alpha.700',
});

export const FlexButtonContainer: CSSObject = {
  h: ['unset', null, '6'],
  fontSize: '2xs',
  gap: '2',
  flexDir: ['column', null, 'row'],
};
